import { hotjar } from 'react-hotjar';
import configuration from './../configuration/server';

export function initializeHotjar() {
    const { STAGE } = configuration;
    const hj = configuration[STAGE].hotjar || false;
    if (hj) {
        hotjar.initialize(hj.hjid, hj.hjsv);
    }
}



// WEBPACK FOOTER //
// ./src/utilities/hotjar.jsx